import * as React from "react";

import { Modal } from "src/library/components/Modal";
import {
  FormRow,
  Input,
  Radio
} from "src/library/components/Forms";
import { CustomerDropStatuses } from "src/core/customers/api/customers.api";

import {
  IDrop,
  UpdatedDropStatusParams
} from "../api/drops.api";

interface DeactivateDropModalProps {
  dropToDeactivate?: (IDrop & { newStatus: CustomerDropStatuses.Deactivated | CustomerDropStatuses.Suspended }) | null;
  onDismiss: () => void;
  onSave: (dropData: UpdatedDropStatusParams) => void
}

export const DeactivateDropModal: React.FC<DeactivateDropModalProps> = ({
  dropToDeactivate, onDismiss, onSave
}) => {
  const [ shouldCancelOrders, setShouldCancelOrders ] = React.useState(false);
  const [ statusReason, setStatusReason ] = React.useState("");

  /** Handles the form content of the suspend/deactivate modal */
  const SuspendOrDeactivateContent = React.useMemo(() => (
    <div>
      <FormRow>
        <Input
          name="statusReason"
          as="input"
          label="Reason"
          handleChange={e => setStatusReason(e.target.value)}
        />
      </FormRow>

      <FormRow>
        <Radio
          label="Do you want to automatically cancel all future orders for this customer"
          name="cancel-orders"
          handleChange={e => {
            if (e.target.value === "cancel") {
              setShouldCancelOrders(true);
            } else {
              setShouldCancelOrders(false);
            }
          }}
          options={[
            {
              text: "Cancel Orders",
              value: "cancel",
              checked: shouldCancelOrders
            },
            {
              text: "Keep existing orders",
              value: "",
              checked: !shouldCancelOrders
            }
          ]}
        />

      </FormRow>
    </div>
  ), [ shouldCancelOrders ]);

  return (
    <Modal
      show={dropToDeactivate !== null}
      title="Are you sure?"
      body={dropToDeactivate ? `This will set ${dropToDeactivate.name} (#${dropToDeactivate.id}) as ${dropToDeactivate.newStatus} and will prevent them from placing any further orders.` : ""}
      content={(SuspendOrDeactivateContent)}
      type="confirm"
      actions={[
        {
          name: "No, take me back",
          action: () => onDismiss(),
          $buttonType: "secondary"
        },
        {
          name: "Yes, continue",
          action: () => {
            if (dropToDeactivate) {
              // Update the customer
              onSave({
                cancelOrders: shouldCancelOrders,
                branchId: dropToDeactivate.id,
                status: dropToDeactivate.newStatus,
                statusReason
              });
              // Update the dropToDeactivate
              onDismiss();
            }
          },
          $buttonType: "primary"
        }
      ]}
      backgroundAction={() => onDismiss()}
    />
  );
};
